import { Injectable } from '@angular/core';
import { AdminService } from '../../../services/core.admin.service';

import { createPromiseMap, doPromiseAll } from '../../../config/core.promise-utils';

import * as _ from 'lodash-es';

@Injectable()
export class AdminSettingsService {

    constructor(private adminService: AdminService) { }

    getScmConfigItems() {
        return {
            allowChangeScmAccess: { section: 'config', refId: 0, settingName: 'scm.allowChangeScmAccess', defaultValue: '0' },
            gitEnabled: { section: 'config', refId: 0, settingName: 'scm.enableGit', defaultValue: '1' },
            gitUseSshSetting: { section: 'config', refId: 0, settingName: 'scmgit.useSSH', defaultValue: '0' },
            svnEnabled: { section: 'config', refId: 0, settingName: 'scm.enableSvn', defaultValue: '1' },
            cvsEnabled: { section: 'config', refId: 0, settingName: 'scm.enableCvs', defaultValue: '0' },
            svnUseSshSetting: { section: 'config', refId: 0, settingName: 'scmsvn.useSSH', defaultValue: '0' },
            taggingEnabled: { section: 'config', refId: 0, settingName: 'scm.taggingEnabled', defaultValue: '1' },
            allowChangeTagging: { section: 'config', refId: 0, settingName: 'scm.allowChangeTagging', defaultValue: '1' },
            indexingEnabled: { section: 'config', refId: 0, settingName: 'scm.taggingEnabled', defaultValue: '1' },
            allowChangeIndexing: { section: 'config', refId: 0, settingName: 'scm.allowChangeIndexing', defaultValue: '1' },
            gitUseMain: { section: 'config', refId: 0, settingName: 'scmgit.useMain', defaultValue: '0' }
        };
    }

    getScmConfig() {
        const items = this.getScmConfigItems();

        const generator = (v) => {
            return this.adminService.getConfig(v.section, v.refId, v.settingName);
        };

        return doPromiseAll(
            createPromiseMap(
                items, generator
            )
        );
    };

    saveScmConfig = function (settings: any) {

        const f = (s) => this.adminService.postConfig(s);

        const map = _.transform(
            this.getScmConfigItems(),
            (r, v, k) =>  {
                const item = _.extend(
                    v,
                    {
                        'settingValue': _.get(
                            settings, k,
                            v?.defaultValue ?? null
                        )
                    }
                );
                r[k] = item;
                return r;
            }
        );

        return doPromiseAll(
            createPromiseMap(
                map, f
            )
        );
    };

    public ui = {
        settingsToUiFlags: function (settings) {
            return {
                allowChangeScmAccess: _.get(settings, 'allowChangeScmAccess.settingValue', '1') == '1' ? 'yes' : 'no',
                gitSetting: _.get(settings, 'gitEnabled.settingValue', '1') != '1' ? 'off' :
                    (_.get(settings, 'gitUseSshSetting.settingValue', '1') == '1' ? 'ssh' : 'http'),
                svnSetting: _.get(settings, 'svnEnabled.settingValue', '1') != '1' ? 'off' :
                    (_.get(settings, 'svnUseSshSetting.settingValue', '1') == '1' ? 'ssh' : 'http'),
                cvsSetting: _.get(settings, 'cvsEnabled.settingValue', '1') != '1' ? 'off' : 'ssh',
                tagSetting: _.get(settings, 'taggingEnabled.settingValue', '1') != '1' ? 'off' :
                    _.get(settings, 'allowChangeTagging.settingValue', '1') != '1' ? 'no' : 'yes',
                indexSetting: _.get(settings, 'indexingEnabled.settingValue', '2') == 0 ? 'off' :
                    _.get(settings, 'allowChangeIndexing.settingValue', '1') != '1' ? 'no' : 'yes',
                gitUseMain: _.get(settings, 'gitUseMain.settingValue', '1') != '1' ? 'no' : 'yes'
            };
        },

        uiFlagsToSettings: function (flags) {
            return {
                allowChangeScmAccess: _.get(flags, 'allowChangeScmAccess', 'yes') === 'yes' ? '1' : '0',
                gitEnabled: _.get(flags, 'gitSetting', 'off') === 'off' ? '0' : '1',
                gitUseSshSetting: _.get(flags, 'gitSetting', 'http') === 'ssh' ? '1' : '0',
                svnEnabled: _.get(flags, 'svnSetting', 'off') === 'off' ? '0' : '1',
                cvsEnabled: _.get(flags, 'cvsSetting', 'off') === 'off' ? '0' : '1',
                svnUseSshSetting: _.get(flags, 'svnSetting', 'http') === 'ssh' ? '1' : '0',
                taggingEnabled: _.get(flags, 'tagSetting', 'off') === 'off' ? '0' : '1',
                allowChangeTagging: _.get(flags, 'tagSetting', 'yes') === 'yes' ? '1' : '0',
                indexingEnabled: _.get(flags, 'indexSetting', 'off') === 'off' ? '0' : '1',
                allowChangeIndexing: _.get(flags, 'indexSetting', 'yes') === 'yes' ? '1' : '0',
                gitUseMain: _.get(flags, 'gitUseMain', 'no') === 'yes' ? '1' : '0'
            };
        }
    };
}